'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { NavigationMenuItem } from '@kit/ui/navigation-menu';
import { cn } from '@kit/ui/utils';

export function SiteNavigationItem({
  path,
  children,
}: React.PropsWithChildren<{ path: string }>) {
  const pathname = usePathname();
  const route = path.split('#')[0];
  const isActive =
    route === '/'
      ? pathname === '/'
      : pathname === route || pathname.startsWith(`${route}/`);
  const isExternal = path.startsWith('http');
  const className = cn(
    'inline-flex min-h-11 items-center rounded-md text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-4',
    isActive
      ? 'text-foreground'
      : 'text-muted-foreground hover:text-foreground',
  );
  return (
    <NavigationMenuItem>
      {isExternal ? (
        <a
          className={className}
          href={path}
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      ) : (
        <Link
          className={className}
          href={path}
          aria-current={isActive ? 'page' : undefined}
        >
          {children}
        </Link>
      )}
    </NavigationMenuItem>
  );
}
